'use client';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { tv } from 'tailwind-variants';

import { Body } from '../typography/Body';
import { Label } from '../typography/Label';
import { Button } from './Button';
import { FlexContainer } from './FlexContainer';

import type { IconDefinition } from '@icons/icon-types';

export interface NullStateProps {
  className?: string;
  children?: React.ReactNode;
  icon?: IconDefinition;
  title?: string;
  actionButton?: {
    text: string;
    icon?: IconDefinition;
    onClick: () => void;
  };
}

const nullState = tv({
  slots: {
    base: 'w-full gap-4 py-12 h-full',
    iconContainer: 'bg-background-secondary rounded w-9 h-9',
    icon: 'text-content-secondary text-base',
    title: 'text-content-secondary text-center w-full',
  },
});

function NullState({ className, children, icon, title = 'No results', actionButton }: NullStateProps) {
  const { base, iconContainer, icon: iconClass, title: titleClass } = nullState();

  return (
    <FlexContainer className={base({ className })} direction="column" items="center" justify="start">
      {icon && (
        <FlexContainer className={iconContainer()} items="center" justify="center">
          <FontAwesomeIcon className={iconClass()} icon={icon} />
        </FlexContainer>
      )}
      <Body className={titleClass()} size="md" weight="medium">
        {title}
      </Body>
      {actionButton && (
        <Button className="px-4" onClick={actionButton.onClick} size="md" variant="secondary">
          {actionButton.icon && <FontAwesomeIcon icon={actionButton.icon} />}
          <Label size="md" weight="medium">
            {actionButton.text}
          </Label>
        </Button>
      )}
      {children}
    </FlexContainer>
  );
}

export default NullState;
